import type { SwarmType } from '@/graphql/types';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { StatusBadge } from '../../statusBadge/StatusBadge';
import Tooltip from '../../../utils/tooltip';
import { formatSwarmType, type SupportedSwarmTypes } from './swarmCompatibility';

export function SwarmIncompatibilityNotice({ swarmType }: { swarmType: SwarmType }): JSX.Element {
    return (
        <Tooltip
            content={interpolate(
                gettext('ELEMENT_INCOMPATIBLE_WITH_SENSOR_TYPE'),
                { swarmType: formatSwarmType(swarmType) },
                true
            )}
        >
            <button
                type="button"
                className="mb-1 block w-fit cursor-help rounded-full focus-visible:outline focus-visible:outline-2 focus-visible:outline-amber-500"
            >
                <StatusBadge
                    status="inactive"
                    label={gettext('INCOMPATIBLE')}
                    icon={<FontAwesomeIcon icon={faCircleInfo} />}
                    className="border-amber-300 bg-amber-50 px-2 py-0.5 text-[10px] text-amber-800"
                />
            </button>
        </Tooltip>
    );
}

export function SwarmTypeBadges({
    supportedSwarmTypes,
}: {
    supportedSwarmTypes: SupportedSwarmTypes;
}): JSX.Element | null {
    if (supportedSwarmTypes === null) {
        return (
            <span className="inline-flex rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-slate-600">
                {gettext('ALL_SENSOR_TYPES')}
            </span>
        );
    }

    return (
        <span className="inline-flex flex-wrap gap-1">
            {supportedSwarmTypes.map((swarmType) => (
                <span
                    key={swarmType}
                    className="inline-flex rounded-full bg-teal-50 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-teal-700"
                >
                    {formatSwarmType(swarmType)}
                </span>
            ))}
        </span>
    );
}
